import React from 'react';
import classNames from 'classnames';

interface IProps {
	label: React.ReactNode;
	isActive: boolean;
	onClick: () => void;
	additionalLabel?: React.ReactNode;
	hasError?: boolean;
	dataTest?: string;
}

export const TabItem: React.FC<IProps> = ({ label, isActive, onClick, additionalLabel, hasError, dataTest }) => {
	const containerClasses = classNames(
		'py-3 border-0 border-b-2 border-solid flex items-center gap-1 text-base font-bold whitespace-nowrap select-none',
		{
			'border-purple-07-new text-purple-07-new cursor-default': isActive,
			'border-transparent cursor-pointer hover:text-purple-07-new': !isActive,
			'text-red-06-new': !isActive && hasError,
			'text-grey-10-new': !isActive && !hasError,
		},
	);

	return (
		<div className={containerClasses} onClick={onClick} data-test={dataTest}>
			{label}
			{additionalLabel}
			{isActive && hasError && <span className="w-2 h-2 rounded-full bg-red-06-new shrink-0" />}
		</div>
	);
};
